// src/components/PerformanceLineChart.tsx

import React from 'react';
import { Card } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import { ChartData } from './Dashboard';

interface PerformanceLineChartProps {
  data: ChartData[];
}

const PerformanceLineChart: React.FC<PerformanceLineChartProps> = ({ data }) => {
  const yAxisTicks = [30000, 60000, 90000, 120000, 150000, 200000]; // Based on image scale

  const formatYAxis = (tick: number) => {
    if (tick === 200000) return '2L';
    if (tick === 150000) return '1.5L';
    if (tick === 90000) return '90K';
    // Add other specific formats if needed, otherwise default to K
    return `${tick / 1000}K`;
  };

  return (
    <Card title="Performance Line Chart" className="shadow-none border border-gray-100 mt-6">
      <div style={{ width: '100%', height: 400 }}>
        <ResponsiveContainer>
          <LineChart data={data} margin={{ top: 10, right: 0, left: 10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} />
            <YAxis
              domain={[30000, 200000]}
              ticks={yAxisTicks}
              tickFormatter={formatYAxis}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#3b82f6" // Blue line color
              dot={{ stroke: '#3b82f6', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6 }}
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default PerformanceLineChart;